import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`React powers components in Gatsby sites that are `}<a parentName="p" {...{
        "href": "/docs/glossary#hydration"
      }}>{`rehydrated`}</a>{`, whatever you can do in React you can do with Gatsby.`}</p>
    <p>{`Your components can pull in whatever data they need from any source in the data layer.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      